import { Injectable, Injector, TransferState } from '@angular/core';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {GoogleAuthenticationService} from '../login/google-authentication.service';
import { SessionExpiredDialogService } from 'src/app/shared/services/session-expired-dialog.service';

@Injectable({
  providedIn: 'root'
})

export class HostInterceptor implements HttpInterceptor {
  private googleAuthenticationService:GoogleAuthenticationService;

  private AppInjector: Injector;

  constructor(private ts: TransferState, private injector: Injector ) {
    this.AppInjector = this.injector;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {

    if(req.url.includes('app.config.json')) {
      return next.handle(req);
    }

    this.googleAuthenticationService = this.AppInjector.get(GoogleAuthenticationService);

    const idToken = this.googleAuthenticationService.getAccessToken();

    const setHeaders: Record<string, string> = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',

      //security Dont Remove it
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
      'X-Frame-Options': 'sameorigin',
      'X-XSS-Protection': '1'
    };

    if (!req.headers.has('Authorization') && idToken && idToken !== 'undefined' && idToken !== 'null' && idToken.trim() !== '') {
      setHeaders['Authorization'] = `Bearer ${idToken}`;
    }

    const request = req.clone({ url: req.url, setHeaders });

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && request.headers.get('Authorization')?.startsWith('Bearer ')) {
          this.AppInjector.get(SessionExpiredDialogService).open();
        }
        return throwError(() => error);
      })
    );
  }
}
